import styled, { css } from 'styled-components';
import Paper from '@material-ui/core/Paper';
import { kassimBlue, makeTransparent } from '../style/theme';

export const containerCss = css`
    position: relative;
    overflow: hidden;
`;

const MainContainer = styled(Paper)`
    ${containerCss}
`;

export const HelpButton = styled.a.attrs({ target: 'help-page', rel: 'help' })`
    background: ${makeTransparent(kassimBlue, 0.4)};
    position: absolute;
    top: -12px;
    right: -12px;
    width: 36px;
    height: 36px;
    color: #ffffff;
    border-radius: 0px 4px 0px 36px;
    transition: all 500ms;
    text-align: center;
    user-select: none;
    cursor: pointer;
    z-index: 2;

    & span {
        position: absolute;
        top: 12px;
        right: 16px;
        transition: all 500ms;
    }

    &:hover {
        top: 0;
        right: 0;
        background: ${kassimBlue};
        box-shadow: -1px 1px 5px 1px #00000080;
    }

    &:hover span {
        top: 2px;
        right: 9px;
        font-size: 150%;
        font-weight: bold;
    }
`;

const PanelWithHelp = ({ children, helpUrl, ...props }) => {
    return (
        <MainContainer {...props}>
            {helpUrl && (
                <HelpButton href={helpUrl}>
                    <span>?</span>
                </HelpButton>
            )}
            {children}
        </MainContainer>
    );
};

export default PanelWithHelp;
